import React, { useState, forwardRef } from "react";
import "../multiplierMaster/MultiplierMaster.scss";
import { components } from "react-select";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import DeleteModal from "../../components/common/DeleteModal";
import { default as ReactSelect } from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";
// datepicker start
const ExampleCustomInput = forwardRef(({ value, onClick, onChange }, ref) => (
  <input
    value={value}
    className="example-custom-input form-control"
    onClick={onClick}
    onChange={onChange}
    ref={ref}
  ></input>
));
// datepicker end
const style = {
  control: (base) => ({
    ...base,
    boxShadow: "none",
    border: "1px solid #B4BABF",
    backgroundColor: "#F9FBFC",
    fontSize: "14px",
    minHeight: "35px",
    height: "35px",
    borderRadius: "6px",
    color: "#000000",
    whiteSpace: "nowrap",
  }),
};
const Option = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        />{" "}
        <label>{props.label}</label>
      </components.Option>
    </div>
  );
};

const colourOptions = [
  { value: "ocean1", label: "Ocean" },
  { value: "blue", label: "Blue" },
  { value: "purple", label: "Purple" },
  { value: "red", label: "Red" },
  { value: "orange", label: "Orange" },
  { value: "yellow", label: "Yellow" },
  { value: "green", label: "Green" },
  { value: "forest", label: "Forest" },
  { value: "slate", label: "Slate" },
  { value: "silver", label: "Silver" },
];

const ViewMultiplier = () => {
  const [distributertag, setDistributerTag] = useState([]);
  const handleChange = (selected) => {
    setDistributerTag(selected);
  };

  const [startDate, setStartDate] = useState(new Date());

  return (
    <div className="container-fluid view-multiplier-sec pl-5 pr-5">
      <section className="multiplier-view-sec mt-3">
        <div className="row">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="header">
                      <h1>Product</h1>
                    </div>
                  </div>
                </div>
                <div className="row product-group-table-row mt-1">
                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                    <div className="table-responsive">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th>Product Group</th>
                            <th className="text-center">Factory Multiplier</th>
                            <th className="text-center">Approved Multiplier</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1.5 hour rated static curtain fire damper</td>
                            <td className="text-center">0.5000</td>
                            <td className="text-center">--</td>
                          </tr>
                          <tr>
                            <td>1.5 hour rated static curtain fire damper</td>
                            <td className="text-center">0.5000</td>
                            <td className="text-center">--</td>
                          </tr>
                          <tr>
                            <td>1.5 hour rated static curtain fire damper</td>
                            <td className="text-center">0.5000</td>
                            <td className="text-center">--</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="text-right mob-mt-13 mob-mb-15">
              <Link to="/multiplier-master">
                <button className="btn back-btn" type="button">
                  Back
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- deleteModal--> */}
      <DeleteModal />

      {/* <!-- saveSuccessModal--> */}
      <SaveSuccessModel SuccessName="New quotation created successfully" />
    </div>
  );
};

export default ViewMultiplier;
